import { atom } from "jotai";
import { DEFAULT_TOOLBOX_CONFIG } from "./AppToolboxSlot.constants";
import type { ToolboxConfig } from "./AppToolboxSlot.types";

export const toolboxConfigAtom = atom<ToolboxConfig>(DEFAULT_TOOLBOX_CONFIG);
